<!--
  AbstractCard.svelte — the standard content container.

  Built on the `widget` primitive rather than flowbite's `Card`: `Card` carries
  a fixed background and a max-width, both of which fight the depth system —
  nest two of them and the inner one vanishes into the outer.  A `widget`
  instead takes its surface from the depth ramp in `app.css`, so nesting reads
  correctly in both themes with no props.

  Padding stays at `p-5` (rather than the `widget` default of `p-3`) so the
  spacing of existing pages is unchanged; a caller's own `p-*` still wins,
  since utilities are emitted after components.

  `flex w-full flex-col` reproduces flowbite `Card`'s own base layout, which
  several pages lay out against — a plain block would collapse their column
  spacing.
-->
<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		/** Extra classes for the container. */
		class?: string;
		/** Card content. */
		children?: Snippet;
		/** Remaining attributes are spread onto the container element. */
		[key: string]: unknown;
	}

	let { children, class: className = '', ...restProps }: Props = $props();
</script>

<div class="widget flex w-full flex-col p-5 {className}" {...restProps}>
	{@render children?.()}
</div>
